"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeHtml = exports.isFalseOrWhitespace = exports.getOverlap = void 0;
/** 匹配返回两个字符串的交集，xbc abcd => bc */
function getOverlap(source, target) {
    if (!source || !target)
        return '';
    let index = source.length;
    while (index) {
        let temp = source.slice(0, index--);
        if (temp && target.indexOf(temp) > -1)
            return temp;
    }
}
exports.getOverlap = getOverlap;
function isFalseOrWhitespace(str) {
    if (!str || typeof str !== 'string') {
        return true;
    }
    return str.trim().length === 0;
}
exports.isFalseOrWhitespace = isFalseOrWhitespace;
function escapeHtml(html) {
    const matchObj = { '<': '&lt;', '>': '&gt;', '&': '&amp;' };
    return html.replace(/[<>&]/g, match => matchObj[match] || match);
}
exports.escapeHtml = escapeHtml;
